import { FC } from "react";

import { TraceDetailContent } from "./trace-detail-content";

interface IAiConversationDetailsPlainProps {
  rawReasoning: string;
  searchTerm?: string;
}

export const AiConversationDetailsPlain: FC<
  IAiConversationDetailsPlainProps
> = ({ rawReasoning, searchTerm }) => (
  <TraceDetailContent rawReasoning={rawReasoning} searchTerm={searchTerm} />
);
